<main id="main" class="main__offset-header">
  <section class="container">
    <h1>Terms and Conditions</h1>

    <div class="row">
      <div class="col-12 col-md-6">
        <h2>Open Maps for Europe</h2>
        <p>
          Open Maps For Europe is an online service that provides free-to-use maps from more than 40
          European countries. The datasets are created using official map, geospatial and land
          information from official, national sources.
        </p>
        <p>
          The project is coordinated by EuroGeographics, the not-for-profit membership association
          for European National Mapping, Cadastral and Land Registration Authorities (NMCAs), in
          partnership with the National Geographic Institute (NGI) Belgium.
        </p>

        <h3>Data Protection Notice</h3>
        <p>
          EuroGeographics is committed to ensuring the protection of personal data. All personal
          data are processed in accordance with Regulation (EU) 2016/679 of the European Parliament
          and of the Council of 27 April 2016 on the protection of natural persons with regard to
          the processing of personal data and on the free movement of such data, and repealing
          Directive 95/46/EC (General Data Protection Regulation). Personal data are processed for
          the management of activities linked to the operation of Open Maps For Europe, specifically
          email addresses.
        </p>
        <p>
          To allow for the delivery of services and datasets from Open Maps For Europe, we need to
          continue to store your email address because it is directly linked to your token. If you
          would like us to delete your email address from our records, please contact us. Please
          note this will remove your access to any services on Open Maps For Europe.
        </p>
        <p>
          Please see our
          <button type="button" (click)="openPrivacyModal()" class="btn btn-link p-0">
            Privacy Notice
          </button>
          for more information.
        </p>
        <h3>Interface Website</h3>
        <p>
          The Open Maps For Europe interface enables users to discover, view, license and download
          the open datasets developed by the project.
        </p>
        <p>
          We aim to keep this information up to date and accurate. We accept no responsibility or
          liability whatsoever for any inaccuracies. If errors are brought to our attention, we will
          try to correct them. <a routerLink="/contact">Report an error here</a>.
        </p>
        <p>Our aim is to minimise disruption caused by technical errors.</p>
      </div>
      <div class="col-12 col-md-6">
        <h3>Reusing content and copyright</h3>
        <p>
          The terms and conditions set out here apply to the general content of the Open Maps For
          Europe User Interface.
        </p>
        <ul>
          <li>
            The
            <button type="button" (click)="openLicenseTermsModal()" class="btn btn-link p-0">
              EuroGeographics Open Data licence
            </button>
            sets out how you may use and reuse the datasets available through Open Maps For Europe.
            By using each service or dataset you are deemed to have accepted the EuroGeographics
            open data licence. The licence must be accepted before you receive any links to the
            datasets or service. You can view the full licence
            <button type="button" (click)="openLicenseTermsModal()" class="btn btn-link p-0">
              here
            </button>
          </li>
          <li>
            The content of this website is protected by EU copyright laws and treaties around the
            world.
          </li>
          <li>
            You may reuse information contained on this website provided that you acknowledge Open
            Maps For Europe and EuroGeographics as the source.
          </li>
          <li>
            You may create a hyperlink to the home page under a non-exclusive and revocable licence.
          </li>
          <li>
            You may not use any of EuroGeographics’ trademarks as part of any hyperlink without our
            written agreement for you to do so.
          </li>
        </ul>

        <h3>Links to other websites</h3>
        <p>
          This website may contain links to other websites that are not under our control and are
          not maintained by us.
        </p>
        <ul>
          <li>
            We are not responsible for the content of such websites and accept not liability for
            their use.
          </li>
          <li>
            We provide these links for your convenience only. We do not endorse, edit or vet the
            material on such websites.
          </li>
        </ul>
        <p>By using this website, you accept these terms and conditions.</p>
      </div>
    </div>
  </section>
</main>
<app-footer showBackToTop="true" target="header"></app-footer>
